module.exports = __webpack_public_path__ + "img/photo_240400745_1.15f679fc.jpg";